"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentPaths = exports.pageIcons = exports.defaultInsertableDelimiters = exports.InsertableVariableValues = exports.fillInsertedVariableValues = exports.insertableTemplateVariables = exports.ACCOUNT_CANCELED_BACKEND_VALUE = exports.TRIAL_ACCOUNT_NUMBER = exports.CLIENT_COMMAND_LOCAL_STORAGE_KEY = exports.CUSTOMER_LABEL_PLURAL = exports.CUSTOMER_LABEL_SINGULAR = exports.APP_VERSION = exports.ERROR_GENERIC_MESSAGE = exports.ERROR_ACCOUNT_NOT_CREATED = exports.GOOGLE_PLACEID_API_URI = exports.TRIBLEY_CONTACT_URL = exports.TRIBELY_SIGNUP_URL = exports.TRIBELY_SUPPORT_PHONE = exports.TRIBELY_SUPPORT_EMAIL = exports.ENVIRONMENT = exports.APP_ID = exports.GOOGLE_PLACEID_API_KEY = exports.BASE_API_URI = exports.WRITE_API_KEY = exports.QUERY_API_KEY = void 0;
var Send_1 = require("@material-ui/icons/Send");
var History_1 = require("@material-ui/icons/History");
var AccountCircle_1 = require("@material-ui/icons/AccountCircle");
var Tune_1 = require("@material-ui/icons/Tune");
var Home_1 = require("@material-ui/icons/Home");
var utils_1 = require("./utils");
require('dotenv').config();
exports.QUERY_API_KEY = process.env.REACT_APP_TRIBELY_MESSAGING_QUERY_API_KEY;
exports.WRITE_API_KEY = process.env.REACT_APP_TRIBELY_MESSAGING_WRITE_API_KEY;
exports.BASE_API_URI = process.env.REACT_APP_TRIBELY_MESSAGING_API_URI;
exports.GOOGLE_PLACEID_API_KEY = process.env.REACT_APP_TRIBELY_MESSAGING_GOOGLE_PLACEID_API_KEY;
exports.APP_ID = process.env.REACT_APP_TRIBELY_MESSAGING_APP_ID;
exports.ENVIRONMENT = process.env.NODE_ENV;
exports.TRIBELY_SUPPORT_EMAIL = 'support@tribely.io';
exports.TRIBELY_SUPPORT_PHONE = '(800) 965-4963';
exports.TRIBELY_SIGNUP_URL = 'https://www.tribely.io/signup';
exports.TRIBLEY_CONTACT_URL = 'https://www.tribely.io/contact';
exports.GOOGLE_PLACEID_API_URI = 'https://api.tribely.io/google/places';
exports.ERROR_ACCOUNT_NOT_CREATED = '5001';
exports.ERROR_GENERIC_MESSAGE = 'Something went wrong. Try refreshing your page.';
exports.APP_VERSION = process.env.REACT_APP_VERSION;
exports.CUSTOMER_LABEL_SINGULAR = 'customer';
exports.CUSTOMER_LABEL_PLURAL = 'customers';
exports.CLIENT_COMMAND_LOCAL_STORAGE_KEY = 'tribelyReviews_lastClientCommand';
exports.TRIAL_ACCOUNT_NUMBER = '00000000';
exports.ACCOUNT_CANCELED_BACKEND_VALUE = "canceled";
exports.insertableTemplateVariables = ["firstName", "lastName"];
var fillInsertedVariableValues = function (text, values) {
    if (values === void 0) { values = InsertableVariableValues.Empty(); }
    var result = text;
    for (var i = 0; i < Object.keys(values).length; i++) {
        result = result.replace(new RegExp(exports.defaultInsertableDelimiters.startDelimiter + exports.insertableTemplateVariables[i] + exports.defaultInsertableDelimiters.endDelimiter, 'g'), values[exports.insertableTemplateVariables[i]]);
    }
    return result;
};
exports.fillInsertedVariableValues = fillInsertedVariableValues;
var InsertableVariableValues = /** @class */ (function () {
    function InsertableVariableValues(firstName, lastName) {
        this.firstName = firstName;
        this.lastName = lastName;
        if (firstName == "") {
            this.firstName = InsertableVariableValues.Empty().firstName;
        }
        if (lastName == "") {
            this.lastName = InsertableVariableValues.Empty().lastName;
        }
    }
    InsertableVariableValues.Empty = function () {
        return new InsertableVariableValues(exports.defaultInsertableDelimiters.startDelimiter + "firstName" + exports.defaultInsertableDelimiters.endDelimiter, exports.defaultInsertableDelimiters.startDelimiter + "lastName" + exports.defaultInsertableDelimiters.endDelimiter);
    };
    return InsertableVariableValues;
}());
exports.InsertableVariableValues = InsertableVariableValues;
exports.defaultInsertableDelimiters = new utils_1.InsertableDelimiters("{", "}");
exports.pageIcons = {
    Home: Home_1.default,
    GoogleReviewTemplate: Tune_1.default,
    Message: Send_1.default,
    MessagesHistory: History_1.default,
    Account: AccountCircle_1.default
};
exports.componentPaths = {
    Home: '/',
    GoogleReviewTemplate: '/google-review-template',
    Message: '/message',
    MessagesHistory: '/messages-history',
    Account: '/account'
};
//# sourceMappingURL=configs.js.map